import * as angular from "angular";

angular
  .module('bringoz.admin.lean-planning')
  .factory('PlanningRoutesAPI', PlanningRoutesAPI);

function PlanningRoutesAPI (){
    return {
      base: `/leanPlanning/routes`,
      infiniteScroll: {
        address: `/leanPlanning/routes`,
        cmd: 'GET'
      },
      idKey: 'rid',
      actions: {
        createRouteNew: {
          address: 'new',
          cmd: 'PUT',
          updateable: true
        },
        getRoutes: {
          address: '',
          cmd: 'GET',
          updateable: false
        },
        getSuggestedServices: {
          address: '{id}/actions/deliveries',
          cmd: 'GET',
          updateable: true
        },
        putDelivery: {
          address: 'actions/deliveries',
          cmd: 'PUT',
          updateable: true
        },

        addServicesToRouteSyncTimeWindow: {
          address: 'edit/syncTimeWindow',
          cmd: 'POST',
          updateable: false
        },
        createRouteFromServicesSyncTimeWindow: {
          address: 'new/syncTimeWindow',
          cmd: 'PUT',
          updateable: false
        },
        editGroupSequence: {
          address: 'actions/editSequence/{groupId}',
          cmd: 'POST',
          updateable: false
        },
        removeDelivery: {
          address: 'actions/deliveries',
          cmd: 'DELETE',
          updateable: true
        },
        getAssignSuggestions: {
          address: 'actions/assign',
          cmd: 'GET',
          updateable: true
        },
        assignRoute: {
          address: 'actions/assign/{agentId}',
          cmd: 'POST',
          updateable: true,
        },
        assignRoutes: {
          address: 'actions/assign/{agentId}',
          cmd: 'POST',
          updateable: true,
        },
        optimizeRoute: {
          address: '{id}/optimize',
          cmd: 'POST',
          updateable: true
        },
        editRoutes: {
          address: 'edit',
          cmd: 'POST'
        },
        updateRouteSettings: {
          address: '{id}/edit/settings',
          cmd: 'POST'
        },
        exportRoutes: {
          address: 'export',
          cmd: 'POST',
          updateable: false
        },
        exportIntegrationRoutes: {
          address: 'export/provider/{providerType}',
          cmd: 'GET',
          updateable: false
        },
        recreateRoute: {
          address: '{id}/transfer',
          cmd: 'POST',
          updateable: true
        },
        editBlockedState: {
          address: '{id}/block',
          cmd: 'POST',
          updateable: true
        },
        validateAssignment: {
          address: 'actions/validateAssignment',
          cmd: 'POST',
          updateable: false
        }
      }
    }
}
